import React, { useEffect, useRef, useState } from 'react';
import sparklesIcon from '/assets/icons/sparkles.svg'; // Make sure this path is correct based on your setup
import ctaBackground from '/assets/cta/Travel Advertise with us-07.avif';
import arrow from '/assets/arrow.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const CampaignCTASection = () => {
    // State and logic for the Custom Multi-Select Dropdown
    const [isInterestOpen, setIsInterestOpen] = useState(false);
    const [selectedInterests, setSelectedInterests] = useState([]);
    const interestDropdownRef = useRef(null);

    const interestsList = [
        "Sponsored Content",
        "Social Media Campaign",
        "Banner Placement",
        "Destination Feature",
        "Newsletter Feature"
    ];

    const toggleInterest = (interest) => {
        setSelectedInterests((prev) =>
            prev.includes(interest)
                ? prev.filter((i) => i !== interest)
                : [...prev, interest]
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const formData = new FormData(event.currentTarget);
        const name = formData.get('name') || 'Not provided';
        const brandName = formData.get('brandName') || 'Not provided';
        const phoneNumber = formData.get('phoneNumber') || 'Not provided';
        const emailAddress = formData.get('emailAddress') || 'Not provided';
        const website = formData.get('website') || 'Not provided';
        const promotionType = formData.get('promotionType') || 'Not provided';
        const message = formData.get('message') || 'Not provided';
        const interests = selectedInterests.length > 0 ? selectedInterests.join(', ') : 'Not provided';

        const whatsappMessage = `Hi Travel Rethink Ways
        %0A%0AI'm interested in exploring partnership opportunities with your platform.%0A%0AName: ${name}%0ABrand Name: ${brandName}%0APhone: ${phoneNumber}%0AEmail: ${emailAddress}%0AWebsite / Social Profile: ${website}%0APromotion Type: ${promotionType}%0ACollaboration Interest: ${interests}%0AMessage: ${message}`;

        window.open(`https://wa.me/918438506813?text=${whatsappMessage}`, '_blank', 'noopener,noreferrer');
    };

    const handleWhatsAppClick = () => {
        window.open(
            'https://wa.me/918438506813?text=Hi%20Travel%20Rethink%20Ways%0A%0AI%27m%20interested%20in%20exploring%20partnership%20opportunities%20with%20your%20platform.',
            '_blank',
            'noopener,noreferrer'
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (interestDropdownRef.current && !interestDropdownRef.current.contains(event.target)) {
                setIsInterestOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);

    return (
        <section className="relative w-full min-h-[100dvh] h-auto lg:h-[650px] 2xl:h-[900px] py-10 lg:py-0 bg-black overflow-hidden flex items-center">

            {/* Main Banner Container - Stretches full width for the background image */}
            <div className="w-full flex-grow relative rounded-none overflow-hidden shadow-2xl h-full flex items-center">

                {/* Background Image */}
                <div className="absolute inset-0 w-full h-full z-0">
                    <img
                        src={ctaBackground}
                        alt="Aerial ocean view"
                        className="w-full h-full object-cover"
                    />
                    {/* Mobile contrast overlay to ensure readability; transparent on desktop */}
                    <div className="absolute inset-0 bg-black/40 lg:bg-transparent pointer-events-none"></div>
                </div>

                {/* Content Container - Constrained to max-w-[1500px] for perfect desktop viewing */}
                <div className="relative z-10 w-full max-w-[1500px] mx-auto px-1 sm:px-10 lg:px-12 xl:px-16 grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 items-center py-10 lg:py-0">

                    {/* --- Left Column: Text Content --- */}
                    <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-xl xl:max-w-2xl self-start lg:self-center relative lg:-top-[60px] mx-auto lg:mx-0 w-full">

                        {/* Small Label */}
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#d02525]  border-gray-800 mb-5 sm:mb-6 shadow-sm">
                            <span className="text-white font-poppins text-[10px] sm:text-xs md:text-sm font-semibold tracking-widest uppercase">
                                Start Your Campaign
                            </span>
                        </div>

                        {/* Main Headline */}
                        <h2 className="text-[32px] xs:text-4xl md:text-5xl lg:text-[46px] xl:text-[50px] 2xl:text-[72px] font-medium text-white leading-[1.2] lg:leading-[1.1] mb-4 sm:mb-6 tracking-tight">
                            <span className="block whitespace-normal sm:whitespace-nowrap">Ready To Build</span>
                            <span className="block whitespace-normal sm:whitespace-nowrap">Your Next Campaign</span>
                        </h2>

                        {/* Subtext */}
                        <p className="text-gray-100 lg:text-gray-300 font-poppins text-[18px] sm:text-lg lg:text-xl 2xl:text-2xl leading-[1.6] whitespace-normal lg:whitespace-nowrap mb-6 sm:mb-8 lg:mb-5 max-w-[95%] lg:max-w-none">
                            Let’s Build the Future of Travel Discovery Together.
                        </p>

                        <button
                            type="button"
                            onClick={handleWhatsAppClick}
                            className="inline-flex items-center justify-center gap-2 sm:gap-2 w-auto 2xl:w-[175px] h-[44px] 2xl:h-[50px] mt-0 sm:mt-2 px-5 2xl:px-6 bg-[#15803d] hover:bg-[#15803d] transition-colors text-white text-[14px] font-poppins font-semibold rounded-[30px] whitespace-nowrap shadow-lg"
                        >
                            <FontAwesomeIcon icon={faWhatsapp} className="text-white w-[20px] h-[20px] sm:w-[24px] sm:h-[24px] 2xl:w-[24px] 2xl:h-[24px]" aria-hidden="true" />
                            <span className="text-[18px] sm:text-[17px] 2xl:text-[18px] font-bold">Starts Here</span>
                        </button>

                    </div>

                    {/* --- Right Side: Form Container --- */}
                    <div className="w-[92%] sm:w-full max-w-md md:max-w-lg lg:max-w-md xl:max-w-[480px] mb-4 lg:mb-0 mx-auto lg:ml-auto lg:mr-0 flex justify-center lg:justify-end mt-4 lg:mt-0">

                        <div className="bg-white p-6 sm:p-8 lg:p-8 xl:p-10 rounded-[20px] w-full relative shadow-2xl">

                            <h2 className="text-1xl sm:text-3xl lg:text-3xl xl:text-2xl font-bold text-[#d02525] mb-6 sm:mb-8 text-center font-yeseva">
                                Reach the  Next-Gen Travelers
                            </h2>

                            <form className="space-y-1 sm:space-y-4" onSubmit={handleSubmit}>

                                {/* Clean Bottom-Border Inputs */}
                                <div>
                                    <input name="name" type="text" placeholder="Your Name" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-[15px] sm:text-base" required />
                                </div>
                                <div>
                                    <input name="brandName" type="text" placeholder="Brand Name" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-[15px] sm:text-base" required />
                                </div>
                                <div>
                                    <input name="phoneNumber" type="tel" placeholder="Phone Number" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-[15px] sm:text-base" required />
                                </div>
                                <div>
                                    <input name="emailAddress" type="email" placeholder="Email Address" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-[15px] sm:text-base" required />
                                </div>
                                <div>
                                    <input name="website" type="text" placeholder="Website / Social Profile" className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-[15px] sm:text-base" />
                                </div>

                                {/* Custom Multi-Select Checkbox Dropdown */}
                                <div className="relative" ref={interestDropdownRef}>
                                    <button
                                        type="button"
                                        className="w-full bg-transparent border-0 border-b border-gray-300 px-1 py-2 cursor-pointer flex justify-between items-center text-[15px] sm:text-base transition-colors focus:outline-none focus:border-gray-900"
                                        onClick={() => setIsInterestOpen(!isInterestOpen)}
                                        aria-expanded={isInterestOpen}
                                        aria-haspopup="listbox"
                                    >
                                        <span className={selectedInterests.length > 0 ? "text-gray-800 truncate pr-4" : "text-gray-500"}>
                                            {selectedInterests.length > 0 ? selectedInterests.join(', ') : "Collaboration Interest"}
                                        </span>
                                        <img src={arrow} alt="caret" className="h-3 w-3 text-gray-500 shrink-0" />
                                    </button>

                                    {isInterestOpen && (
                                        <div className="absolute z-50 top-full left-0 right-0 mt-1 bg-white border border-gray-100 shadow-xl rounded-md overflow-hidden py-2 max-h-40 sm:max-h-48 overflow-y-auto">
                                            {interestsList.map((interest) => (
                                                <label key={interest} className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                                                    <input
                                                        type="checkbox"
                                                        className="mr-3 w-4 h-4 text-[#D02525] border-gray-300 rounded focus:ring-2 focus:ring-[#D02525] cursor-pointer"
                                                        checked={selectedInterests.includes(interest)}
                                                        onChange={() => toggleInterest(interest)}
                                                    />
                                                    <span className="text-[13px] sm:text-sm text-gray-900">{interest}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Textarea */}
                                <div>
                                    <textarea
                                        name="message"
                                        placeholder="Message"
                                        rows="1"
                                        className="w-full bg-transparent border-0 border-b border-gray-300 text-gray-800 placeholder-gray-500 px-1 py-2 mt-2 focus:outline-none focus:ring-0 focus:border-gray-900 transition-colors text-[15px] sm:text-base resize-none"
                                    ></textarea>
                                </div>

                                <button type="submit" className="w-full bg-[#d02525] text-white font-poppins font-black text-sm sm:text-base tracking-[0.05em] uppercase py-3 sm:py-3.5 mt-2 sm:mt-4 rounded-md hover:bg-[#a61c1c] shadow-md transition-colors duration-300">
                                    Start Your Campaign
                                </button>

                                <p className="text-[7px] sm:text-[13px] lg:text-[9px] text-gray-500 text-center leading-relaxed px-1 mt-3 sm:mt-4">
                                    We collaborate with selected Travel & Tourism brands aligned with our ecosystem.
                                </p>
                            </form>
                        </div>
                    </div>

                </div>
            </div>

        </section>
    );
};

export default CampaignCTASection;